import { render, staticRenderFns } from "./ContatoForm.vue?vue&type=template&id=32b5c38e&scoped=true&"
import script from "./ContatoForm.vue?vue&type=script&lang=js&"
export * from "./ContatoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b5c38e",
  null
  
)

export default component.exports